/* oxlint-disable react/no-unknown-property */

import { fontBoyrun } from "./boyrun";
import { fontInter } from "./inter";
import { fontPrimary } from "./primary";
import { fontSecondary } from "./secondary";

export const globalFontClass = "font-primary";

export const Fonts = () => (
  <style
    jsx
    global
  >{`
    :root {
      --font-primary: ${fontPrimary.style.fontFamily};
      --font-secondary: ${fontSecondary.style.fontFamily};
      --font-boyrun: ${fontBoyrun.style.fontFamily};
      --font-inter: ${fontInter.style.fontFamily};
    }
  `}</style>
);
